export default __webpack_public_path__ + "static/media/Mark-4-Suit-08.51303a02.jpg";